import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=329a4c3d&scoped=true"
import script from "./ButtonSecondary.vue?vue&type=script&lang=js"
export * from "./ButtonSecondary.vue?vue&type=script&lang=js"
import style0 from "./ButtonSecondary.vue?vue&type=style&index=0&id=329a4c3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a4c3d",
  null
  
)

export default component.exports